import { SubscriptionPlan } from "../models/subscription-plan.model";

export enum PatientFeatues {
  AI_Dental_Scan = "Virtual Checkup (AI Dental Scan)",
  Treatment_Verification = "Treatment Verification (second opinion)",
  Emergency_Consultation = "Emergency Consultation (dentist consultation)",
  Product_Recommendation = "Product Recommendation",
  Find_A_Dentist = "Find a dentist",
  Download_Report = "Download Report",
}

export const PLANS_PRIORITY = {
  [SubscriptionPlan.Basic]: 1,
  [SubscriptionPlan.Premium]: 2,
  [SubscriptionPlan.Complete]: 3,
};

export const PATIENT_FEATURES_BY_PLAN: Record<
  PatientFeatues,
  SubscriptionPlan[]
> = {
  [PatientFeatues.AI_Dental_Scan]: [
    SubscriptionPlan.Premium,
    SubscriptionPlan.Complete,
  ],
  [PatientFeatues.Treatment_Verification]: [
    SubscriptionPlan.Premium,
    SubscriptionPlan.Complete,
  ],
  [PatientFeatues.Emergency_Consultation]: [
    SubscriptionPlan.Premium,
    SubscriptionPlan.Complete,
  ],
  [PatientFeatues.Product_Recommendation]: [
    SubscriptionPlan.Basic,
    SubscriptionPlan.Premium,
    SubscriptionPlan.Complete,
  ],
  [PatientFeatues.Find_A_Dentist]: [SubscriptionPlan.Complete],
  [PatientFeatues.Download_Report]: [
    SubscriptionPlan.Basic,
    SubscriptionPlan.Premium,
    SubscriptionPlan.Complete,
  ],
};
